import Panel from './Panel';
import { withErrorBoundary } from '../../SystemComponent/ErrorBoundary';

export default withErrorBoundary('Panel')(Panel);
